"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchCoreDataSecurityApplicationsBulkSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const get_1 = require("../all/get.js");
const patchDataSecurityApplications_1 = require("../../../../api/data-security/patchDataSecurityApplications.js");
const actions_1 = require("../_idMap/actions.js");
exports.patchCoreDataSecurityApplicationsBulkSlice = (0, xuder_1.createPatchAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request) => (0, actions_1.updateApplicationReferences)(request.applicationIds.map((applicationId) => ({
                applicationId,
                classification: request.classification,
                ownerId: request.ownerId,
                stakeholderGroupId: request.stakeholderGroupId,
                stakeholderIds: request.stakeholderIds
            }))),
            () => get_1.getCoreDataSecurityApplicationsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityApplicationsAll()
        ]
    },
    name: name_1.CoreDataSecurityApplicationsBulkName,
    receive: false,
    request: true,
    requestHandler: patchDataSecurityApplications_1.patchDataSecurityApplications
});
//# sourceMappingURL=patch.js.map